<router-outlet></router-outlet>
<ng-template #nzIndicatorTpl>
  <span class="ant-spin-dot">
    <i nz-icon [nzType]="'loading'"></i>
  </span>
</ng-template>